import React from 'react';
import styled from 'styled-components';
import logo from '../../img/png/Logo-fc-analise-so-fc.png';
import close from '../../img/svg/ico-close-interno.svg';

const HeaderWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 1.25rem;
  margin-bottom: 0.35rem;
`;

const CloseLink = styled.a`
  position: absolute;
  right: 0;
  top: 0;
  line-height: 0;
  opacity: 0.88;
  transition: opacity 0.15s ease, transform 0.15s ease;
  padding: 4px;

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }

  img {
    width: 18px;
    height: 18px;
  }
`;

const Logo = styled.img`
  height: 44px;
  margin-bottom: 0.5rem;
`;

const LoginHeader = ({ title }) => (
  <HeaderWrap>
    <CloseLink href="https://www.fcanalise.com.br/" aria-label="Fechar e voltar ao site">
      <img src={close} alt="" />
    </CloseLink>
    <Logo src={logo} alt="Ficha Certa" />
    {typeof title === 'string' ? <span>{title}</span> : title}
  </HeaderWrap>
);

LoginHeader.defaultProps = {
  title: ''
};

export default LoginHeader;
